module.exports = __webpack_public_path__ + "static/media/profile.1fced063.svg";